import moment from 'moment';
import { mapCommentAuthorFromApi } from 'rtkQuery/sharespro/mapper/shared/mapCommentsFromApi';
import { mapReactionListItemFromApi } from 'rtkQuery/sharespro/mapper/shared/mapReactionListItemFromApi';
import { mapPollFromApi } from './mapPollFromApi';
import mapFileFromApi from 'rtkQuery/sharespro/mapper/shared/mapFileFromApi';

const mapArticleListItemFromApi = (
  resp: ApiArticleListItem
): ArticleListItem => {
  return {
    id: resp.id,
    name: resp.name,
    image: resp.image != null ? mapFileFromApi(resp.image) : null,
    text: resp.text,
    video: resp.video != null ? mapFileFromApi(resp.video) : null,
    presentation:
      resp.presentation != null ? mapFileFromApi(resp.presentation) : null,
    description: resp.description,
    url: resp.url,
    viewCount: resp.view_count ?? 0,
    isPrivate: resp.is_private,
    gallery: resp.gallery?.map(mapFileFromApi) ?? [],
    poll: resp.poll != null ? mapPollFromApi(resp.poll) : null,
    publicDate: moment(resp.public_date, 'DD.MM.yyyy hh:mm:ss').toDate(),
    tags: resp.tags.map((tag) => tag.name),
    reactions: resp.reaction_metrics.map(mapReactionListItemFromApi),
    commentsCount: resp.comments_count,
    selectedReactionId: resp.investor_reaction,
    isCommentable: resp.is_commentable,
    commentators: resp.commentators.map(mapCommentAuthorFromApi),
    category: resp.category?.name ?? null,
  };
};

export default mapArticleListItemFromApi;
